import config from "../app-config";
import serverFetch from "../utils/serverFetch";

// DG Group CRUD
export const create_dg_group = async (groupData) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/`,
        method: "POST",
        body: JSON.stringify(groupData)
    })
}

export const get_all_dg_group = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/`,
        method: "GET"
    })
}

export const get_dg_group_by_id = async (dg_id) => {
    if (!dg_id) return { error: "No dg id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/id/${dg_id}`,
        method: "GET"
    })
}

export const update_dg_group = async (dg_id, groupData) => {
    if (!dg_id) return { error: "No dg id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/id/${dg_id}`,
        method: "PUT",
        body: JSON.stringify(groupData)
    })
}

export const delete_dg_group = async (dg_id) => {
    if (!dg_id) return { error: "No dg id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/id/${dg_id}`,
        method: "DELETE"
    })
}

// DG Join Request
export const create_dg_join_request = async (requestData) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/request`,
        method: "POST",
        body: JSON.stringify(requestData)
    })
}

export const get_all_dg_join_requests = async (dg_id) => {
    if (!dg_id) return { error: "No dg id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/request/${dg_id}`,
        method: "GET"
    })
}

export const action_dg_join_request = async (actionData) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/request/action`,
        method: "PUT",
        body: JSON.stringify(actionData)
    })
}

// DG Members
export const add_dg_member = async (memberData) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/members`,
        method: "POST",
        body: JSON.stringify(memberData)
    })
}

export const get_all_dg_members_by_dg_id = async (dg_id) => {
    if (!dg_id) return { error: "No dg id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/members/${dg_id}`,
        method: "GET"
    })
}

export const get_all_dg_leaders_by_dg_id = async (dg_id) => {
    if (!dg_id) return { error: "No dg id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/leaders/${dg_id}`,
        method: "GET"
    })
}

export const remove_dg_member = async (dg_id, memberData) => {
    if (!dg_id) return { error: "No dg id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/members/${dg_id}`,
        method: "DELETE",
        body: JSON.stringify(memberData)
    })
}

export const update_dg_member = async (dg_id, memberData) => {
    if (!dg_id) return { error: "No dg id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/members/${dg_id}`,
        method: "PUT",
        body: JSON.stringify(memberData)
    })
}

// DG Clusters
export const get_all_clusters = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/clusters`,
        method: "GET"
    })
}

export const get_all_groups_by_clusters = async (cluster_id) => {
    if (!cluster_id) return { error: "No cluster id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/clusters/groups/${cluster_id}`,
        method: "GET"
    })
}

export const create_cluster = async (clusterData) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/clusters`,
        method: "POST",
        body: JSON.stringify(clusterData)
    })
}

export const get_cluster_by_id = async (cluster_id) => {
    if (!cluster_id) return { error: "No cluster id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/clusters/id/${cluster_id}`,
        method: "GET"
    })
}

export const update_cluster = async (cluster_id, clusterData) => {
    if (!cluster_id) return { error: "No cluster id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/clusters/id/${cluster_id}`,
        method: "PUT",
        body: JSON.stringify(clusterData)
    })
}

export const delete_cluster = async (cluster_id) => {
    if (!cluster_id) return { error: "No cluster id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/clusters/id/${cluster_id}`,
        method: "DELETE"
    })
}

// DG Public
export const get_all_dg_group_public = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/groups`,
        method: "GET"
    })
}

export const get_dg_status = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/membership/status`,
        method: "GET"
    })
}

export const get_dg_by_id = async (dg_id) => {
    if (!dg_id) return { error: "No dg id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/groups/id/${dg_id}`,
        method: "GET"
    })
}

export const load_dg_home_page = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/home`,
        method: "GET"
    })
}

// DG Calendar
export const get_dg_calendar = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/calendar`,
        method: "GET"
    })
}

export const get_dg_calendar_event = async (event_id) => {
    if (!event_id) return { error: "No event id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/calendar/event/${event_id}`,
        method: "GET"
    })
}

export const create_dg_calendar_event = async (eventData) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/calendar/event`,
        method: "POST",
        body: JSON.stringify(eventData)
    })
}

export const update_dg_calendar_event = async (event_id, eventData) => {
    if (!event_id) return { error: "No event id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/calendar/event/id/${event_id}`,
        method: "PUT",
        body: JSON.stringify(eventData)
    })
}

export const delete_dg_calendar_event = async (event_id) => {
    if (!event_id) return { error: "No event id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/dg/calendar/event/id/${event_id}`,
        method: "DELETE"
    })
}
